import AccessProfileRequests from '../../server/accessProfile';
import { addLoading, removeLoading } from './loading';

export const setAccessProfile = res => ({
  type: 'GET_ACCESS_PROFILE',
  accessProfile: res,
});

export const setAccessProfileTree = res => ({
  type: 'GET_ACCESS_PROFILE_TREE',
  accessProfile: res,
});

export const setAccessProfiles = res => ({
  type: 'GET_ACCESS_PROFILES',
  accessProfiles: res,
});

const createAccessProfile = accessProfile => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AccessProfileRequests.createAccessProfile(accessProfile);
  } finally {
    dispatch(removeLoading());
  }
};

const updateAccessProfile = accessProfile => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AccessProfileRequests.updateAccessProfile(accessProfile);
  } finally {
    dispatch(removeLoading());
  }
};

const getAccessProfile = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const accessProfile = await AccessProfileRequests.getAccessProfile(id);
    dispatch(setAccessProfile(accessProfile));
  } finally {
    dispatch(removeLoading());
  }
};

const getAccessProfileTree = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const accessProfileTree = await AccessProfileRequests.getAccessProfileTree(id);
    dispatch(setAccessProfileTree(accessProfileTree));
  } finally {
    dispatch(removeLoading());
  }
};

const getAccessProfiles = (limit, skip, search, force = false, order = '', field = '') => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const accessProfiles = await AccessProfileRequests.getAccessProfiles(limit, skip, search, order, field);
    dispatch(setAccessProfiles(accessProfiles));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

export const getAccessProfilesSelect = (search) => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const accessProfiles = await AccessProfileRequests.getAccessProfiles(1000, 0, search, 'ASC', 'id');
    dispatch(setAccessProfiles(accessProfiles));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};


export const uploadAccessProfile = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await AccessProfileRequests.uploadCsvAccessProfile(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvAccessProfileModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AccessProfileRequests.getCsvAccessProfileModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvAccessProfileReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AccessProfileRequests.getCsvAccessProfilesReport();
  } finally {
    dispatch(removeLoading());
  }
};

const deleteAccessProfile = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AccessProfileRequests.deleteAccessProfile(id);
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createAccessProfile,
  getAccessProfile,
  getAccessProfileTree,
  getAccessProfiles,
  updateAccessProfile,
  uploadAccessProfile,
  getCsvAccessProfileReport,
  getCsvAccessProfileModel,
  deleteAccessProfile,
  getAccessProfilesSelect,
};
